




























































import { Component, Vue } from "vue-property-decorator";
import DashboardTemplate from "@/views/Layouts/dashboard-template.vue";
import QrcodeVue from "qrcode.vue";
import { ActionTypes } from "@/store/devices/actions";

@Component({
  components: {
    DashboardTemplate,
    QrcodeVue
  },
})
export default class ActivatorApp extends Vue {
  private form = {
    email: ""
  };

  private rules = {
    email: [
      { required: true, message: "Please enter an email", trigger: "blur" }
    ],
  };

  private get androidActivatorAppUrl() {
    return `https://console.viloc.eu/apps/activator?X-VilocSubscription=${this.$typedStore.state.device.settings.apiSubscription}`;
  }

  private onSubmit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        if (await this.$typedStore.dispatch(ActionTypes.InviteActivatorApp, this.form.email)) {
          alert(`An invite was sent to ${this.form.email}.`);
        } else {
          alert("An error occurred. Please try again.");
        }
      }
    });
  }
}
